<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Artboard_1">
                <rect width="36" height="36" opacity="0"/>
            </clipPath>
        </defs>
        <g id="Artboard_1" data-name="Artboard – 1" clip-path="url(#clip-Artboard_1)">
            <g id="Group_14969" data-name="Group 14969" transform="translate(7420.459 -627.586)">
                <rect id="Rectangle_10109" data-name="Rectangle 10109" transform="translate(-7420.459 627.586)" opacity="0" :width="width" :height="height"/>
                <g id="Group_14855" data-name="Group 14855" transform="translate(-7414.204 649.273)">
                    <g id="Group_14852" data-name="Group 14852" transform="translate(-1.506 -13.767)">
                        <path id="Path_4447" class="svg-stroke-color" data-name="Path 4447" d="M27.5,2.724a8.793,8.793,0,0,1-6.339-.109c-2.688-1.236-3.846-2.346-6.912-1-3.065-1.344-4.223-.234-6.912,1A8.793,8.793,0,0,1,1,2.724V19.9a8.8,8.8,0,0,0,6.339-.109c2.689-1.236,3.846-2.347,6.912-1,3.066-1.344,4.224-.234,6.912,1A8.8,8.8,0,0,0,27.5,19.9Z" transform="translate(-1 -1)"  stroke-miterlimit="10" stroke-width="1.5"/>
                        <line id="Line_15" class="svg-stroke-color" data-name="Line 15" y2="17.024" transform="translate(13.251 0.612)"  stroke-miterlimit="10" stroke-width="1.5"/>
                        <g id="Group_14853" data-name="Group 14853" transform="translate(-29.71 2.235)">
                            <g id="Group_14849" data-name="Group 14849" transform="translate(0 0)">
                                <path id="Path_4446" :class="secondaryColor" data-name="Path 4446" d="M21.088,8.323a1.7,1.7,0,1,0-1.7-1.7,1.7,1.7,0,0,0,1.7,1.7m1.77,2.025V9.294H17.93v1.053h1.461v4.611H17.93v1.053h6.32V14.959H22.858Z" transform="translate(29 -3)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "manualIcon",
    props: {
        width: {
            type: Number,
            default: 36
        },
        height: {
            type: Number,
            default: 36
        }
    },
    computed: {
        secondaryColor() {
            return 'svg-secondary-color';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/manualIcon.vue